import React from 'react';
import App from './App';
import { createRoot } from "react-dom/client";
import { configureStore } from "@reduxjs/toolkit";
import { Provider } from "react-redux";
import userReducer from "./features/user";
import resellerReducer from "./features/reseller";
import commonReducer from "./features/common";
import errorDialogReducer from "./features/errorDialog";
import { ThemeProvider, createTheme } from '@mui/material';
import { heIL } from '@mui/material/locale';
import './i18n/config';
import { dirOfLang, getLang } from './Helper';
import { installCaptchaRecovery } from './captcha';
import { installStepUpRecovery } from './stepUp';
import { installSsoExceptionAdapter } from './ssoExceptions';

/**
 * התאוששות מהדלקת הקאפצ'ה באמצע.
 *
 * הגדרות הריסיילר נשמרות אצל המבקר בעוגייה לחמש דקות, ולכן ברגע שההגדרה נדלקת יש
 * חלון שבו מסכים פתוחים עדיין אינם יודעים עליה ונדחים. מותקן פעם אחת, לפני שנוצר
 * המסך הראשון - ראה `captcha.js`.
 */
installCaptchaRecovery();
installStepUpRecovery();
/**
 * סירוב של ה-SSO נושא סטטוס משלו (`401` לסשן שמת, `403` לחשבון שחסום עד להשלמת שלב),
 * ו-`axios` דוחה כל סטטוס כזה. המתאם מחזיר תשובה שנושאת את מעטפת החריגה למסלול הרגיל,
 * כדי שהמסכים יקראו את הקוד שהשרת מסר. ראה `ssoExceptions.js`.
 */
installSsoExceptionAdapter();

const store = configureStore({
    reducer: {
      user: userReducer,
      reseller: resellerReducer,
      common: commonReducer,
      errorDialog: errorDialogReducer
    },
  });


const theme = createTheme({
    palette :{
        primary : {
            main : "#000"
        }
    }
}, heIL);


const rootElement = document.getElementById("root");
const root = createRoot(rootElement);
/**
 * הכיוון לפי השפה שהמסכים עולים בה, ולא `rtl` קשיח.
 *
 * `rtl` קבוע כאן פירושו שמסך שעולה באנגלית מצויר מימין לשמאל עד ש-`Header` יתקן -
 * ובמסך ההתחברות הסלולרי, שאין לו `Header`, לעולם לא. אותו `getLang()` של `i18n`.
 */
document.documentElement.setAttribute("dir", dirOfLang(getLang()));
root.render(
    <Provider store={store}>
    <ThemeProvider theme={theme}>
        <App />
    </ThemeProvider>
    </Provider>
);
